import Api from './Api';
import { API_VERSION } from "@/config/index"

export default {
    GetRegisterOTP(payload) {
        return Api().post(`${API_VERSION}/webapp/getregisterotp`, payload)
    },
    Register(payload) {
        return Api().post(`${API_VERSION}/webapp/register`, payload)
    },
    GetLoginOTP(payload) {
        return Api().post(`${API_VERSION}/webapp/getloginotp`, payload)
    },
    Login(payload) {
        return Api().post(`${API_VERSION}/webapp/login`, payload)
    },
    Delete(payload) {
        return Api().post(`${API_VERSION}/webapp/delete-account`, payload)
    },
    SocialLogin(payload) {
        return Api().post(`${API_VERSION}/webapp/social-login`, payload)
    },
    GuestLogin(payload) {
        return Api().post(`${API_VERSION}/webapp/guest-login`, payload)
    }
}



// WEBPACK FOOTER //
// ./src/apiServices/UserService.js